import axios from "axios";
import { deleteItemWithPosition, swapAndChangePosition } from "@/utils";
import { processAxiosNetworkError } from "@/notify";
import { MAX_PAGE_SIZE } from "@/constants";

export default {
  namespaced: true,
  state: {
    sections: [],
    isSectionsFetching: false,
    isSectionsFetched: false,
  },
  mutations: {
    setSections: function (state, sections) {
      state.sections = sections;
    },
    setSectionsFetching: function (state, isSectionsFetching) {
      state.isSectionsFetching = isSectionsFetching;
    },
    setSectionsFetched: function (state, isSectionsFetched) {
      state.isSectionsFetched = isSectionsFetched;
    },
    swapSections: function (state, { firstPosition, secondPosition }) {
      state.sections = swapAndChangePosition(
        state.sections,
        firstPosition,
        secondPosition,
      );
    },
    addSection: function (state, section) {
      state.sections = [...state.sections, section];
    },
    updateSection: function (state, section) {
      state.sections = state.sections.map((s) => {
        if (s.id === section.id) {
          return section;
        }
        return s;
      });
    },
    deleteSection: function (state, section) {
      state.sections = deleteItemWithPosition(state.sections, section.position);
    },
  },
  getters: {
    sections(state) {
      return state.sections;
    },
    sectionsForProfile(state) {
      return (profile) =>
        state.sections.filter(
          (s) =>
            !s.allowed_entry_grades.length ||
            s.allowed_entry_grades.includes(profile.entry_grade),
        );
    },
  },
  actions: {
    fetchSections(context) {
      if (context.state.isSectionsFetching || context.state.isSectionsFetched) {
        return;
      }
      context.commit("setSectionsFetching", true);
      return axios
        .get("/interview/questions/sections/", { params: { page_size: MAX_PAGE_SIZE } })
        .then(
          (response) => {
            context.commit("setSectionsFetching", false);
            context.commit("setSectionsFetched", true);
            context.commit("setSections", response.data.results);
          },
          (error) => {
            context.commit("setSectionsFetching", false);
            processAxiosNetworkError(error);
          },
        );
    },
  },
};
